export default "__VITE_ASSET__8962126a__"